import { Dispatch } from "redux";
import { SET_SOURCES_REFRESHING, SET_SOURCE_DATA } from "./../reducers/sources";
import { LoadedSourceInfo } from "./../types/global";

import { makeRequest } from "../util";

export const fetchSources = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: SET_SOURCES_REFRESHING });

    const sourcesResp = await makeRequest<LoadedSourceInfo[]>(
      "list_sql_sources",
      {}
    );

    dispatch({
      type: SET_SOURCE_DATA,
      payload: Object.fromEntries(
        sourcesResp.data.map((source: LoadedSourceInfo) => [
          source.name,
          { ...source },
        ])
      ),
    });
  };
};
